import {useAppSelector} from "../../hooks/useAppSelector";
import {TableFilterKey} from "../../model/filters/TableFiltersDefinitions";
import {useDataActions} from "../../hooks/useDataActions";
import {useSearchMeasurementOkeiGuidePageQuery} from "../../store/backend-api/backend.api";
import React, {useEffect} from "react";
import {DEFAULT_MEASUREMENT_OKEI_GUIDE_FILTER} from "../../model/filters/DefaultFilters";
import {GuideTopBox} from "../../components/ui/table-components/GuideTopBox";
import {MeasurementOkeiTable} from "../../components/measurement-okei/MeasurementOkeiTable";

export function MeasurementOkeiGuide() {
    const state = useAppSelector(state => state.sessionStorage.filters)
    const filter = state[TableFilterKey.MEASUREMENT_OKEI_GUIDE_FILTER].filter;

    const {addData} = useDataActions()

    const data = useAppSelector(state => state.data.data[TableFilterKey.MEASUREMENT_OKEI_GUIDE_FILTER])

    const {data: tablePage} = useSearchMeasurementOkeiGuidePageQuery(filter)

    useEffect(() => {
        if (tablePage) {
            if (!data || data.rows.length < (tablePage.pageNumber * DEFAULT_MEASUREMENT_OKEI_GUIDE_FILTER.pageSize) + 1) {
                addData({key: TableFilterKey.MEASUREMENT_OKEI_GUIDE_FILTER, data: tablePage})
            }
        }

    }, [tablePage]);

    return (
        <div className="space-y-3.5 h-[98%]">
            <div>
                <div className="min-w-full flex flex-row">
                    <GuideTopBox tableFilterKey={TableFilterKey.MEASUREMENT_OKEI_GUIDE_FILTER}
                                 searchInfo={"Поиск по ID, наименованию, условному обозначению и группе в ОКЕИ."}/>
                </div>
            </div>
            <div className="h-[90%] bg-transparent rounded-2xl">
                <div className="bg-transparent rounded-2xl h-[100%]">
                    {data && <MeasurementOkeiTable data={data}/>}
                </div>
            </div>
        </div>
    )
}